/**
 * Legacy redirect: /admin/audit → /settings/audit.
 *
 * The audit history surface moved under Settings in the Apr-2026
 * nav re-org. Kept as a redirect so bookmarks keep working.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/audit")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/audit" });
  },
});
